import { BREAKPOINTS } from '@lib/style/breakpoints';
import { debugStore } from '@stores/Debug';
import { useWindowSize } from './window-size';

export function useIsMobile() {
  const [width] = useWindowSize();
  return debugStore.mobileUI && width <= BREAKPOINTS.mobile;
}

/**
 * Non-hook, one-shot viewport check for use OUTSIDE React (stores, managers),
 * where `useIsMobile` can't run. Reads `window.innerWidth` directly, so it's a
 * snapshot at call time — not reactive. Mirrors `useIsMobile`'s conditions.
 */
export function isMobileViewport(): boolean {
  return (
    debugStore.mobileUI && typeof window !== 'undefined' && window.innerWidth <= BREAKPOINTS.mobile
  );
}
